import React, { createContext, useContext, useState } from "react";

const initTemplateInfo = {
  id: 0,
  name: "",
  teams: 0,
  bracket_type: "0",
};

const initiSkyboxTemplateInfo = {
  bracket_id: 0,
  template_id: 0,
};

// Create a context with initial values
const BracketStateContext = createContext({
  isLoading: false,
  setIsLoading: () => {},
  templateInfo: initTemplateInfo,
  setTemplateInfo: () => {},
  skyboxTemplateInfo: initiSkyboxTemplateInfo,
  setSkyboxTemplateInfo: () => {},
});

// Create a context provider component
export const BracketStateProvider = ({ children }) => {
  const [templateInfo, setTemplateInfo] = useState(initTemplateInfo);
  const [skyboxTemplateInfo, setSkyboxTemplateInfo] = useState(
    initiSkyboxTemplateInfo
  );
  const [isLoading, setIsLoading] = useState(false);

  return (
    <BracketStateContext.Provider
      value={{
        isLoading,
        setIsLoading,
        templateInfo,
        setTemplateInfo,
        skyboxTemplateInfo,
        setSkyboxTemplateInfo,
      }}
    >
      {children}
    </BracketStateContext.Provider>
  );
};

// Create a custom hook to use the context
export const useBracketState = () => {
  const context = useContext(BracketStateContext);

  if (!context) {
    throw new Error(
      "useBracketState must be used within a BracketStateProvider"
    );
  }

  return context;
};
